import TopicPage from '../components/TopicPage';

const sections = [
  {
    title: 'Foundations',
    icon: '🏛️',
    cards: [
      {
        icon: '📐',
        title: 'Design Principles',
        level: 'beginner',
        description: 'SOLID, DRY, KISS, and YAGNI — the guiding principles for maintainable system design.',
        topics: ['SOLID', 'Separation of concerns', 'Modularity', 'Coupling & Cohesion'],
      },
      {
        icon: '📊',
        title: 'CAP Theorem',
        level: 'intermediate',
        description: 'Consistency, Availability, Partition tolerance — you can only guarantee two. Design tradeoffs.',
        topics: ['Consistency models', 'Eventual consistency', 'ACID vs BASE', 'CP vs AP'],
      },
      {
        icon: '📏',
        title: 'Back-of-the-Envelope',
        level: 'intermediate',
        description: 'Estimate QPS, storage, bandwidth, and memory requirements for system design interviews.',
        topics: ['Latency numbers', 'QPS calculation', 'Storage math', 'Traffic estimation'],
      },
    ],
  },
  {
    title: 'Scalability Patterns',
    icon: '📈',
    cards: [
      {
        icon: '⚖️',
        title: 'Load Balancing',
        level: 'intermediate',
        description: 'Distribute traffic with round-robin, least-connections, or consistent hashing across servers.',
        topics: ['Round-robin', 'Consistent hashing', 'L4 vs L7', 'Health checks'],
      },
      {
        icon: '💾',
        title: 'Caching',
        level: 'intermediate',
        description: 'Cache-aside, read-through, write-through, and write-behind strategies. Redis vs Memcached.',
        topics: ['Cache-aside', 'TTL', 'Cache invalidation', 'CDN caching'],
      },
      {
        icon: '🔀',
        title: 'Database Sharding',
        level: 'advanced',
        description: 'Horizontal partitioning — range, hash, and directory-based sharding strategies and trade-offs.',
        topics: ['Range sharding', 'Hash sharding', 'Hot spots', 'Resharding'],
      },
      {
        icon: '📋',
        title: 'Read Replicas',
        level: 'intermediate',
        description: 'Scale read-heavy workloads with replicas. Replication lag, consistency windows, and failover.',
        topics: ['Async replication', 'Replication lag', 'Failover', 'CQRS'],
      },
    ],
  },
  {
    title: 'Distributed Systems',
    icon: '🌐',
    cards: [
      {
        icon: '📨',
        title: 'Message Queues',
        level: 'intermediate',
        description: 'Async communication with Kafka, RabbitMQ, SQS. Decouple producers and consumers at scale.',
        topics: ['Kafka topics', 'Consumer groups', 'Dead-letter queues', 'Ordering'],
      },
      {
        icon: '🔗',
        title: 'Service Discovery',
        level: 'intermediate',
        description: 'Client-side vs server-side discovery. Consul, Eureka, and DNS-based service registries.',
        topics: ['Service registry', 'Health checks', 'Consul', 'Kubernetes DNS'],
      },
      {
        icon: '🛡️',
        title: 'Fault Tolerance',
        level: 'advanced',
        description: 'Circuit breakers, retries with exponential backoff, bulkheads, and timeout patterns.',
        topics: ['Circuit breaker', 'Retry storms', 'Bulkhead', 'Timeout'],
      },
      {
        icon: '🔄',
        title: 'Distributed Transactions',
        level: 'advanced',
        description: 'Two-phase commit, Saga pattern (choreography & orchestration) for cross-service transactions.',
        topics: ['2PC', 'Saga pattern', 'Idempotency', 'Compensation'],
      },
    ],
  },
  {
    title: 'Real-World System Designs',
    icon: '🏢',
    cards: [
      {
        icon: '🐦',
        title: 'Twitter / Feed System',
        level: 'advanced',
        description: 'Fanout on write vs read, timeline generation, celebrity problem, and timeline caching.',
        topics: ['Fanout', 'Timeline', 'Pub/Sub', 'Celebrity problem'],
      },
      {
        icon: '🔗',
        title: 'URL Shortener',
        level: 'intermediate',
        description: 'Encode/decode algorithms, collision handling, analytics, custom aliases, and expiration.',
        topics: ['Base62', 'Hash collision', 'Redirect types', 'Analytics'],
      },
      {
        icon: '💬',
        title: 'Chat System',
        level: 'advanced',
        description: 'WebSocket connections, presence detection, message delivery guarantees, and group chat.',
        topics: ['WebSockets', 'Long polling', 'Message ACK', 'Presence'],
      },
      {
        icon: '🎬',
        title: 'Video Streaming',
        level: 'advanced',
        description: 'CDN architecture, adaptive bitrate streaming (HLS/DASH), encoding pipelines, and metadata.',
        topics: ['HLS', 'DASH', 'CDN', 'Transcoding'],
      },
    ],
  },
];

function SystemDesign() {
  return (
    <TopicPage
      title="System Design"
      subtitle="Design scalable, reliable, and maintainable systems — from concepts to real-world architectures."
      icon="🏗️"
      color="#10b981"
      sections={sections}
    />
  );
}

export default SystemDesign;
